import ApiDispatchDrivers from '../api/dispatch/drivers'
class NotifDriverStatus {
  process (VueApp, payload) {
    ApiDispatchDrivers.updateDriverStatus(VueApp, payload.driverId)
  }
}

export default new NotifDriverStatus()



// WEBPACK FOOTER //
// ./src/modules/notifications/notif-driver-status.js